import React from 'react';
import Card from '../../../components/Card';
import IcoMoon from '../../../components/IcoMoon';
import Status from '../../../components/Status';
import Row from '../../../components/Row';
import Col from '../../../components/Col';
import classNames from 'classnames';
import Icon from '../../../components/Icon';
import { useBranding } from '../../../branding/BrandingContextProvider';
import { useDispatch, useSelector } from 'react-redux';
import { applyFilter } from '../../../store/actions/serviceRequestDashboard/filters';

const status = (serviceRequestOverview: any) => [
  {
    glyph: 'declined',
    label: 'Declined',
    count: serviceRequestOverview?.declinedCount ?? 0,
  },
  {
    glyph: 'closed',
    label: 'Closed',
    count: serviceRequestOverview?.closedCount ?? 0,
  },
  {
    glyph: 'submitted',
    label: 'Submitted',
    count: serviceRequestOverview?.submittedCount ?? 0,
  },
  {
    glyph: 'scheduled',
    label: 'Scheduled',
    count: serviceRequestOverview?.scheduledCount ?? 0,
  },
  {
    glyph: 'en-route',
    label: 'En Route',
    count: serviceRequestOverview?.enRouteCount ?? 0,
  },
  {
    glyph: 'on-hold',
    label: 'On Hold',
    count: serviceRequestOverview?.onHoldCount ?? 0,
  },
  {
    glyph: 'in-progress',
    label: 'In Progress',
    count: serviceRequestOverview?.inProgressCount ?? 0,
  },
  {
    glyph: 'resolved',
    label: 'Resolved',
    count: serviceRequestOverview?.resolvedCount ?? 0,
  },
  {
    glyph: 'approved',
    label: 'Approved',
    count: serviceRequestOverview?.approvedCount ?? 0,
  },
  {
    glyph: 'assigned',
    label: 'Assigned',
    count: serviceRequestOverview?.assignedCount ?? 0,
  },
  {
    glyph: 'under-review',
    label: 'Under Review',
    count: serviceRequestOverview?.underReviewCount ?? 0,
  },
  {
    glyph: 'warranty',
    label: 'One Year Warranty',
    count: serviceRequestOverview?.oneYearWarrantyCount ?? 0,
  },
];

const toggleArrayState = (state: any, newValue: any) => {
  let newState: any = state ?? [];
  return newState.includes(newValue)
    ? newState.filter((s: any): boolean => s !== newValue)
    : newState.concat(newValue);
};

const StatusOverviewCard = ({
  serviceRequestOverview,
  onSelectStatus,
}: any) => {
  const { branding } = useBranding();

  const dispatch = useDispatch();
  const { Statuses } =
    useSelector((state: any) => state.serviceRequestDashboardFilters) ?? [];

  const handleSelectStatus = (status) => {
    const newStatuses: any = toggleArrayState(Statuses, status);
    dispatch(applyFilter('Statuses', newStatuses));
    onSelectStatus();
  };

  return (
    <Card
      title="Status Overview"
      body={
        <>
          <Row style={{ marginBottom: '1rem' }}>
            {status(serviceRequestOverview).map((status: any, x: number) => (
              <Col key={x} xs={12} md={6}>
                <div
                  style={{ cursor: 'pointer' }}
                  className={classNames('card__item compact', {
                    card__item__dotted: Statuses?.includes(status.label),
                  })}
                  onClick={() => handleSelectStatus(status.label)}
                >
                  <Status
                    icon={
                      status.label === 'Under Review' ? (
                        <Icon
                          glyph="hourglass-end"
                          weight="light"
                          size="solid"
                        />
                      ) : status.label === 'One Year Warranty' ? (
                        <Icon glyph="certificate" weight="solid" size="solid" />
                      ) : (
                        <IcoMoon glyph={status.glyph} />
                      )
                    }
                    label={status.label}
                  />
                  <div
                    className="card__count"
                    style={{
                      color: branding?.colours?.text?.emphasis ?? undefined,
                    }}
                  >
                    {status.count}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </>
      }
    />
  );
};

export default StatusOverviewCard;
